export function useFieldModalTree(): Promise<any> {
  return import('../module/field-modal-tree');
}
